import React from "react";
import { CellState, StageName } from "../../config/offeringCatalog";
import {
  ADD_ON_CELL,
  NOT_AVAILABLE_CELL,
  stageStyles,
} from "../../config/accentStyles";

interface MatrixCellProps {
  state: CellState;
  stage: StageName;
}

export const CELL_STATE_LABELS: Record<CellState, string> = {
  included: "Included",
  "add-on": "Available Add-On",
  "not-available": "Not Available",
};

const SYMBOLS: Record<CellState, string> = {
  included: "✓",
  "add-on": "+",
  "not-available": "—",
};

const MatrixCell: React.FC<MatrixCellProps> = ({ state, stage }) => {
  const tone =
    state === "included"
      ? `${stageStyles[stage].tintBg} ${stageStyles[stage].ink} font-extrabold`
      : state === "add-on"
        ? `${ADD_ON_CELL} font-bold`
        : `${NOT_AVAILABLE_CELL} font-bold`;

  return (
    <div
      aria-label={`${stage}: ${CELL_STATE_LABELS[state]}`}
      className={`flex min-h-[48px] flex-col items-center justify-center gap-0.5 border-l border-gray-100 dark:border-slate-700/50 md:min-h-[56px] ${tone}`}
      role="img"
    >
      <span
        aria-hidden="true"
        className={
          state === "add-on"
            ? "text-lg leading-none"
            : "text-[15px] leading-none"
        }
      >
        {SYMBOLS[state]}
      </span>
      {/* Rows stack on phones, so each cell names its own stage there. */}
      <span
        aria-hidden="true"
        className="text-[9px] font-semibold uppercase tracking-wide opacity-80 md:hidden"
      >
        {stage}
      </span>
    </div>
  );
};

export default MatrixCell;
